(function () {
  'use strict';
 
  /* ─────────────────────────────────────────────────────────
     CONSTANTS
  ───────────────────────────────────────────────────────── */
  var IS_TOUCH = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
 
  /* ─────────────────────────────────────────────────────────
     PERMANENT CHECKOUT BUTTON — always visible, always works
  ───────────────────────────────────────────────────────── */
  function injectCheckoutButton() {
    if (document.getElementById('csk-checkout-btn')) return;

    var btn = document.createElement('a');
    btn.id = 'csk-checkout-btn';
    btn.href = '/checkout';
    btn.setAttribute('aria-label', 'Go to checkout');

    btn.innerHTML = '<span class="csk-checkout-badge" id="csk-checkout-badge" style="display:none;">0</span>' +
                    '<span class="csk-checkout-label">Check out →</span>';

    btn.style.cssText = [
      'position: fixed',
      'bottom: 16px',
      'right: 16px',
      'z-index: 99999',
      'background: #ffcccc',        // brand pink
      'color: #000000',             // black text
      'border: 1.5px solid #006666', // brand teal border
      'border-radius: 50px',
      'padding: 7px 14px',
      'font-size: 12px',
      'font-weight: 700',
      'text-decoration: none',
      'cursor: pointer',
      'box-shadow: 0 3px 10px rgba(0,102,102,0.25)',  // teal-tinted shadow
      'transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
      'display: flex',
      'align-items: center',
      'gap: 6px',
      'letter-spacing: 0.3px',
      'line-height: 1'
    ].join(';');

    // Badge style
    var style = document.createElement('style');
    style.textContent =
      '#csk-checkout-btn .csk-checkout-badge {' +
        'background: #006666;' +        // teal badge
        'color: #ffffff;' +             // white number
        'border-radius: 50%;' +
        'width: 16px;' +
        'height: 16px;' +
        'font-size: 10px;' +
        'font-weight: 900;' +
        'display: inline-flex;' +
        'align-items: center;' +
        'justify-content: center;' +
        'flex-shrink: 0;' +
      '}' +
      '#csk-checkout-btn .csk-checkout-label {' +
        'font-size: 12px;' +
        'font-weight: 700;' +
        'color: #000000;' +             // black text
        'white-space: nowrap;' +
      '}' +
      // Hover state
      '#csk-checkout-btn:hover {' +
        'background: #006666 !important;' +   // flips to teal on hover
        'border-color: #006666 !important;' +
      '}' +
      '#csk-checkout-btn:hover .csk-checkout-label {' +
        'color: #ffffff !important;' +         // white text on hover
      '}' +
      '#csk-checkout-btn:hover .csk-checkout-badge {' +
        'background: #ffcccc !important;' +    // flips to pink badge on hover
        'color: #000000 !important;' +         // black number on hover
      '}';

    document.head.appendChild(style);

    btn.addEventListener('mouseenter', function () {
      btn.style.transform = 'scale(1.04)';
      btn.style.boxShadow = '0 5px 14px rgba(0,102,102,0.35)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = 'scale(1)';
      btn.style.boxShadow = '0 3px 10px rgba(0,102,102,0.25)';
    });

    document.body.appendChild(btn);
  }

  /* ─────────────────────────────────────────────────────────
     CHECKOUT BUTTON BADGE — show cart item count
  ───────────────────────────────────────────────────────── */
  function updateCheckoutBadge(count) {
    var badge = document.getElementById('csk-checkout-badge');
    if (!badge) return;

    if (count > 0) {
      badge.textContent = count;
      badge.style.display = 'inline-flex';
    } else {
      badge.style.display = 'none';
    }
  }

  /* ─────────────────────────────────────────────────────────
     FETCH INITIAL CART COUNT on page load
  ───────────────────────────────────────────────────────── */
  function fetchInitialCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          updateCheckoutBadge(cart.item_count);
        }
      })
      .catch(function () {});
  }

  /* ─────────────────────────────────────────────────────────
     TOAST — created ONCE, hidden by default via CSS transform
     (checkout button removed from toast)
  ───────────────────────────────────────────────────────── */
  var toastTimer = null;
 
  function injectToast() {
    if (document.getElementById('csk-toast')) return;
 
    var toast = document.createElement('div');
    toast.id = 'csk-toast';
    toast.innerHTML =
      '<span class="csk-toast-icon">🧦</span>' +
      '<div class="csk-toast-text">' +
        '<span class="csk-toast-title">Added to cart!</span>' +
        '<span class="csk-toast-item" id="csk-toast-product-name"></span>' +
      '</div>';
 
    document.body.appendChild(toast);
  }
 
  function showToast(productTitle) {
    var toast = document.getElementById('csk-toast');
    if (!toast) return;
 
    var nameEl = document.getElementById('csk-toast-product-name');
    if (nameEl) nameEl.textContent = productTitle || '';
 
    toast.classList.add('show');
 
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, 4000);
  }
 
  /* ─────────────────────────────────────────────────────────
     CART COUNT — update the header bubble
  ───────────────────────────────────────────────────────── */
  function updateCartCount(newCount) {
    document.querySelectorAll(
      '.cart-count-bubble span[aria-hidden="true"]'
    ).forEach(function (el) { el.textContent = newCount; });
 
    document.querySelectorAll(
      '.cart-count-bubble span:not([aria-hidden])'
    ).forEach(function (el) { el.textContent = newCount + ' items'; });
 
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      el.removeAttribute('hidden');
      el.style.display = '';
    });

    // Update permanent checkout button badge
    updateCheckoutBadge(newCount);
  }
 
  /* ─────────────────────────────────────────────────────────
     AJAX — fetch variant id then add to cart
  ───────────────────────────────────────────────────────── */
  function getFirstAvailableVariant(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (product) {
        var available = product.variants.find(function (v) { return v.available; });
        return {
          variantId : available ? available.id : product.variants[0].id,
          title     : product.title,
          available : !!available
        };
      });
  }
 
  function addToCart(variantId, productTitle, btn) {
    btn.classList.add('loading');
    btn.textContent = 'Adding… ⏳';
 
    return fetch('/cart/add.js', {
      method  : 'POST',
      headers : { 'Content-Type': 'application/json' },
      body    : JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart/add failed: ' + r.status);
      return fetch('/cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
 
      btn.classList.remove('loading');
      btn.classList.add('success');
      btn.textContent = '✓ Added!';
 
      showToast(productTitle);
 
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('product:added', {
        detail: { cart: cart, variantId: variantId, productTitle: productTitle }
      }));
 
      setTimeout(function () {
        btn.classList.remove('success');
        btn.textContent = 'Quick Add 🧦';
      }, 2200);
    })
    .catch(function (err) {
      console.warn('[CSK Quick Add] Error:', err);
      btn.classList.remove('loading');
      btn.textContent = 'Quick Add 🧦';
    });
  }
 
  /* ─────────────────────────────────────────────────────────
     EXTRACT product handle from URL
  ───────────────────────────────────────────────────────── */
  function getHandle(href) {
    var m = href.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }
 
  /* ─────────────────────────────────────────────────────────
     POSITION helper
  ───────────────────────────────────────────────────────── */
  function positionButton(btn, card) {
    var inner = card.querySelector('.card__inner, .card__media');
    if (inner) {
      var topPx = inner.offsetTop + inner.offsetHeight;
      btn.style.top  = (topPx - 50) + 'px';
    }
  }
 
  /* ─────────────────────────────────────────────────────────
     INJECT Quick-Add button into a product card
  ───────────────────────────────────────────────────────── */
  function injectButton(card) {
    if (card.querySelector('.csk-quick-add-btn')) return;
 
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
 
    var handle = getHandle(link.href);
    if (!handle) return;
 
    if (/bundle|gift-card|gift_card/i.test(handle)) return;
 
    var wrapper = card.closest('.card-wrapper') || card;
    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }
 
        var btn = document.createElement('button');
    btn.className = 'csk-quick-add-btn';
    btn.textContent = 'Quick Add 🧦';
    btn.setAttribute('aria-label', 'Quick add to cart');
    btn.setAttribute('type', 'button');
    btn.dataset.handle = handle;
    btn.style.color = '#ffffff';  // ← white text
 
    if (IS_TOUCH) {
      btn.classList.add('csk-always-visible');
    }
 
    wrapper.appendChild(btn);
    positionButton(btn, wrapper);
 
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
 
      if (btn.classList.contains('loading') || btn.classList.contains('success')) return;
 
      getFirstAvailableVariant(handle)
        .then(function (data) {
          if (!data) { window.location.href = link.href; return; }
 
          if (!data.available) {
            btn.textContent = 'Sold Out 😢';
            btn.style.background = '#cccccc';
            btn.style.color = '#666';
            btn.style.cursor = 'default';
            return;
          }
 
          addToCart(data.variantId, data.title, btn);
        })
        .catch(function () {
          window.location.href = link.href;
        });
    });
  }
 
  /* ─────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────── */
  function initQuickAdd() {
    var path = window.location.pathname;
    var isCollectionPage =
      path.includes('/collections/') ||
      path === '/' ||
      path.includes('/search');
 
    if (!isCollectionPage) return;
 
    document.querySelectorAll('.card-wrapper').forEach(injectButton);
  }
 
  function observeNewCards() {
    var debounceTimer = null;
 
    var observer = new MutationObserver(function (mutations) {
      var hasNew = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.matches('.card-wrapper') || n.querySelector('.card-wrapper')
          );
        });
      });
      if (hasNew) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(initQuickAdd, 120);
      }
    });
 
    observer.observe(document.body, { childList: true, subtree: true });
  }
 
  function initResizeHandler() {
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.card-wrapper').forEach(function (wrapper) {
          var btn = wrapper.querySelector('.csk-quick-add-btn');
          if (btn) positionButton(btn, wrapper);
        });
      }, 200);
    });
  }
 
  function fixContinueShopping() {
    var cartNotif = document.getElementById('cart-notification');
    if (!cartNotif) return;
 
    function patchLinks() {
      cartNotif.querySelectorAll('a, button').forEach(function (el) {
        var txt = (el.textContent || '').trim().toLowerCase();
        if (!txt.includes('continue')) return;
 
        if (el.tagName === 'A' && el.getAttribute('href') === '/') {
          el.setAttribute('href', '/collections/all');
        }
 
        if (el.tagName === 'BUTTON' && !el.dataset.cskPatched) {
          el.dataset.cskPatched = '1';
          el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var closeBtn = cartNotif.querySelector('[class*="close"], [aria-label*="close" i]');
            if (closeBtn) closeBtn.click();
            window.location.href = '/collections/all';
          });
        }
      });
    }
 
    var notifObserver = new MutationObserver(patchLinks);
    notifObserver.observe(cartNotif, {
      attributes : true,
      subtree    : true,
      childList  : true,
      attributeFilter: ['class', 'aria-hidden', 'open']
    });
 
    patchLinks();
  }
 
  /* ─────────────────────────────────────────────────────────
     MAIN ENTRY POINT
  ───────────────────────────────────────────────────────── */
  function init() {
    injectToast();
    injectCheckoutButton();
    fetchInitialCartCount();
    initQuickAdd();
    observeNewCards();
    initResizeHandler();
    fixContinueShopping();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  document.addEventListener('shopify:section:load', initQuickAdd);
 
})();
